import React from 'react';
import { motion } from 'framer-motion';

const BlurText = ({
  text = '',
  delay = 150,
  className = '',
  animateBy = 'words', // 'words' | 'letters'
  direction = 'top', // 'top' | 'bottom'
  threshold = 0.1,
  rootMargin = '0px',
  animationFrom,
  animationTo,
  easing = 'easeOut',
  onAnimationComplete
}) => {
  const elements = animateBy === 'words' ? text.split(' ') : text.split('');

  const defaultFrom =
    direction === 'top'
      ? { filter: 'blur(10px)', opacity: 0, transform: 'translate3d(0,-20px,0)' }
      : { filter: 'blur(10px)', opacity: 0, transform: 'translate3d(0,20px,0)' };

  const defaultTo = [
    {
      filter: 'blur(5px)',
      opacity: 0.5,
      transform: direction === 'top' ? 'translate3d(0,5px,0)' : 'translate3d(0,-5px,0)'
    },
    { filter: 'blur(0px)', opacity: 1, transform: 'translate3d(0,0px,0)' }
  ];

  const fromState = animationFrom || defaultFrom;
  const toState = animationTo || defaultTo;

  return (
    <p className={`blur-text-paragraph ${className}`} style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', textAlign: 'center', width: '100%' }}>
      {elements.map((element, index) => (
        <motion.span
          key={index}
          initial={fromState}
          whileInView={toState[1]}
          viewport={{ once: true, amount: threshold, margin: rootMargin }}
          transition={{
            duration: 0.4,
            delay: (index * delay) / 1000,
            ease: easing
          }}
          onAnimationComplete={index === elements.length - 1 ? onAnimationComplete : undefined}
          style={{ display: 'inline-block', willChange: 'transform, filter, opacity' }}
        >
          {element === ' ' ? '\u00A0' : element}
          {animateBy === 'words' && index < elements.length - 1 && '\u00A0'}
        </motion.span>
      ))}
    </p>
  );
};

export default BlurText;
